@if (bookmarkCategoryToDelete) {
  <p-confirmDialog
    key="bookmarkCategoryDeleteDialog"
    #cd
    styleClass="w-9"
    appendTo="body"
    [blockScroll]="false">
    <ng-template pTemplate="headless" let-message>
      <div class="p-card border-round pt-1 p-4">
        <app-header
          icon="fas fa-trash"
          [text]="
            bookmarkCategoryToDelete.title + ' wirklich löschen?'
          "></app-header>

        @if (
          (categoryBookmarks && categoryBookmarks.length) ||
          (categoryStories && categoryStories.length)
        ) {
          <p appAlertStyle="warning" class="p-3">
            <i class="fas fa-exclamation-triangle"></i>
            Enthaltene Berichte werden dabei unwiderruflich gelöscht.
            Enthaltene Ansichten, die ausschließlich diesem Themenbereich
            zugeordnet sind, werden ebenfalls gelöscht; Ansichten, die noch
            weiteren Themenbereichen zugeordnet sind, bleiben dort erhalten
            und werden nur aus diesem Bereich entfernt.
          </p>
          <p-divider></p-divider>
          @if (categoryBookmarks && categoryBookmarks.length) {
            <app-header
              icon="fas fa-note-sticky"
              text="Enthaltene Ansichten"
              [count]="categoryBookmarks.length"></app-header>
            @for (bookmark of categoryBookmarks; track bookmark._id) {
              <div
                class="flex align-items-center gap-3 py-2 border-top-1 surface-border">
                <i class="fas fa-note-sticky"></i>
                <span>{{ bookmark.title }}</span>
              </div>
            }
          }

          @if (categoryStories && categoryStories.length) {
            <app-header
              icon="fas fa-file-lines"
              text="Enthaltene Berichte"
              [count]="categoryStories.length"></app-header>
            @for (story of categoryStories; track story._id) {
              <div
                class="flex align-items-center gap-3 py-2 border-top-1 surface-border">
                <i class="fas fa-note-sticky"></i>
                <span>{{ story.title }}</span>
              </div>
            }
          }
        } @else {
          <app-alert [canToggle]="false" styleClass="p-3">
            <i class="fas fa-circle-info"></i>
            "{{ bookmarkCategoryToDelete.title }}" sind keine Ansichten oder
            Berichte zugeordnet. Er kann sicher gelöscht werden.
          </app-alert>
        }

        <p-divider></p-divider>
        <div class="flex align-items-center gap-3 mt-4">
          <button
            [rounded]="true"
            [outlined]="true"
            severity="secondary"
            pButton
            icon="fas fa-times"
            label="nein, abbrechen"
            (click)="cd.reject()"></button>
          <button
            [rounded]="true"
            pButton
            [severity]="'danger'"
            icon="fas fa-check"
            label="ja, löschen"
            (click)="cd.accept()"
            class="ml-auto"></button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
}
